<!--
/**
* @name: List.vue
* @description: 用户管理列表页
* @author: 于海威
* @create: 2020/08/07 17:21:46
* @update: 2020/08/07 17:21:46
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-input placeholder="请输入用户姓名" v-model="para.name" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入手机号码" v-model="para.username" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择角色" v-model="para.roleId" clearable>
          <k-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.name" :selected="item.id == para.roleId">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddUser">新建</y-button>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择销售渠道" v-model="para.saleChannelCodes" clearable>
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" v-model="para.isEnabled" clearable>
          <k-option v-for="v in statusList" :key="v.value" :value="v.value" :label="v.label">{{ v.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <div style="width: 240px;"></div>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="userList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowResetPopup" @after-close="onClosePwd" @after-cancel="onCancelPwd" @after-ok="onSavePwd()" okText="确定" title="重置密码">
      <y-popup-body size="small">
        <y-form contentWidth="250px">
          <y-form-item title="请输入新密码：" required>
            <k-input
              maxlength="10"
              placeholder="请设置由英文+数字组成的8-10位字符"
              v-validate="'minLength(8)|maxLength(10)|regex(/^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/)'"
              block
              v-model="newPassword"
              clearable
            ></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DETAIL,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DISABLED,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_ENABLED,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_PAGE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DELETE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_RESET_PASSWORD,
} from "@/assets/modules/apiList";

const initPara = () => ({
  isEnabled: "",
  name: "",
  pageCurrent: 1,
  pageSize: 15,
  roleId: "",
  saleChannelCodes: "",
  username: "",
});
export default {
  data() {
    return {
      userList: [],
      roleList: [],
      para: initPara(),
      total: 0,
      isLoading: false,
      isShowResetPopup: false,
      channelList: [],
      statusList: [
        { value: true, label: "启用" },
        { value: false, label: "停用" },
      ],
      newPassword: "",
      userName: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "用户账号",
          field: "username",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender:row=>(
            <div>
              <insensitive val={row.username} type="phone" isShowEye={false}></insensitive>
            </div>
          )
        },
        {
          name: "用户姓名",
          field: "name",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender:row=>(
            <div>
              <insensitive val={row.name} type="name" isShowEye={false}></insensitive>
            </div>
          )
        },
        {
          name: "拥有角色",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            let tmp = [];
            if (row.systemRoleVOList && row.systemRoleVOList.length > 0) {
              row.systemRoleVOList.forEach((d) => {
                tmp.push(d.name);
              });
            }
            tmp = tmp.map((m) => <p>{m}</p>);
            return <div class={this.css.row}>{tmp}</div>;
          },
        },
        {
          name: "销售渠道",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let tmp = [];
            if (row.saleChannelCodes.indexOf(",") > -1) {
              let codes = row.saleChannelCodes.split(",").map((m) => m.toString());
              this.channelList.forEach((d) => {
                codes.forEach((f) => {
                  if (f == d.code) {
                    tmp.push(d.name);
                  }
                });
              });
            } else {
              this.channelList.forEach((d) => {
                if (row.saleChannelCodes == d.code) {
                  tmp.push(d.name);
                }
              });
            }
            tmp = tmp.map((m) => <p>{m}</p>);
            return <div class={this.css.row}>{tmp}</div>;
          },
        },
        {
          name: "职位",
          field: "position",
          style: {
            width: 60,
            textAlign: "center",
          },
        },
        {
          name: "所在部门",
          field: "department",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "启用状态",
          field: "",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 140,
            textAlign: "center",
          },
          customRender: (row) => {
            const resetPwdButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onResetPwd(row);
                }}
              >
                重置密码
              </a>
            );
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return (
              <div>
                {resetPwdButton}&#12288;{viewButton}&#12288;{editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getUserList();
    },
    onReset() {
      this.para = initPara();
      this.getUserList();
    },
    onView(row) {
      this.$controller.open({
        name: "userAdd",
        query: {
          refresh: new Date() - 0,
          username: row.username,
          view: 1,
        },
        title: "查看用户",
      });
    },
    onEdit(row) {
      // 新开标签
      this.$controller.open({
        name: "userAdd",
        query: {
          refresh: new Date() - 0,
          username: row.username,
          id: row.id,
          edit: 1,
        },
        title: "编辑用户",
      });
    },
    onDelete(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该用户？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DELETE,
            para: { username: row.username },
          })
            .then(() => {
              this.isLoading = false;
              this.getUserList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onResetPwd(row) {
      this.isShowResetPopup = true;
      this.userName = row.username;
    },
    onClosePwd() {
      this.newPassword = "";
    },
    onCancelPwd() {
      this.newPassword = "";
    },
    onSavePwd() {
      let { tip } = this.$root;
       if (!this.newPassword) {
        return tip("请输入新密码");
      } else {
        let reg = /^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/;
        if (!reg.test(this.newPassword)) {
          return tip("请输入由英文+数字组成的8-10位字符");
        }
      }
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_RESET_PASSWORD,
        para: { username: this.userName, password: this.newPassword },
      })
        .then((res) => {
          this.isLoading = false;
          this.isShowResetPopup = false;
          this.newPassword = "";
          this.getUserList();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onChangeStatus(row) {
      let para = {
        username: row.username,
      };
      let api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_ENABLED;
      if (row.isEnabled) {
        api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_DISABLED;
      }
      this.$dialog({
        title: "提示",
        content: `你是否要${row.isEnabled ? "停用" : "启用"}此用户？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api,
            para,
          })
            .then((res) => {
              this.isLoading = false;
              this.getUserList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onAddUser() {
      this.$controller.open({
        name: "userAdd",
        query: {
          refresh: new Date() - 0,
        },
        title: "新建用户",
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getUserList();
    },
    getUserList() {
      let para = JSON.parse(JSON.stringify(this.para));
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_PAGE,
        para,
      })
        .then((res) => {
          this.userList = res.pageList;
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getRoleList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_LIST,
        para: {
          isEnabled: true,
        },
      }).then((res) => {
        this.roleList = res || [];
      });
    },
    // 获取渠道信息
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
  },
  created() {
    this.getUserList();
    this.getChannelList();
    this.getRoleList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getUserList();
    next();
  },
};
</script>

<style lang="postcss" module="css">
.row {
  margin: 5px 0;
  line-height: 1.5;
}
</style>
